module.exports = "<div class=\"container\">\n  <vue-component name=\"TabbedUsersPage\" />\n</div>\n";